module.exports = __webpack_public_path__ + "img/section4_title.1b30a7b6.png";